var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex flex-wrap justify-center items-center gap-2"},[_c('div',{staticClass:"circle",class:_vm.value && 'green'}),_c('p',[_vm._v(_vm._s(_vm.label))])])
}
var staticRenderFns = []

export { render, staticRenderFns }